/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type SomniaContractListRequest = {
    term?: string;
    sortField?: SomniaContractListRequest.sortField;
    sortDirection?: SomniaContractListRequest.sortDirection;
    page?: number;
    size?: number;
};

export namespace SomniaContractListRequest {

    export enum sortField {
        TRX_COUNT = 'TRX_COUNT',
        VERIFIED_AT = 'VERIFIED_AT',
    }

    export enum sortDirection {
        ASC = 'ASC',
        DESC = 'DESC',
    }


}

